

import commonUtil from '../../utils/commonUtil';
import serverClientUtil from '../../utils/serverClientUtil';

export function loadYahoocontact(code) {
  const _input = {};
  _input.code = code;
  _input.redirect_uri = serverClientUtil.getYahooRedirectURI();
  _input.grant_type = 'authorization_code';
  return commonUtil.triggerServerRequest({ url: '/api/getTokenYahoo', data: _input, method: 'POST' });
}

